// extracted by mini-css-extract-plugin
export default {"layout":"ClientProfileLayout_layout__Z2Jx0"};